export default __webpack_public_path__ + "static/media/save.7dfeea1d.png";